/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 7/21/2023
 */

import React from "react"
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material"
import LoadingButton from "@mui/lab/LoadingButton"
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt"

const ConfirmationModal = ({ open, isSubmit, handleAccept, onClose }) => {
  return (
    <Dialog open={open} PaperProps={{ style: { borderRadius: "10px" } }}>
      <DialogTitle
        sx={{ backgroundColor: "#f59959", color: "#fff" }}
        textAlign="center"
      >
        Are you sure you want to proceed ?
      </DialogTitle>
      <br/>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="error">
          Cancel
        </Button>
        <LoadingButton
          loading={isSubmit}
          loadingPosition="start"
          startIcon={<ThumbUpAltIcon />}
          variant="contained"
          color="success"
          onClick={handleAccept}
        >
          Yes
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationModal
